<app-page-breadcrumb pageTitle="Images" />
<div class="space-y-5 sm:space-y-6">
  <div>
    <app-component-card title="Responsive image">
      <app-responsive-image />
    </app-component-card>
  </div>

  <div>
    <app-component-card title="Image in 2 Grid">
      <app-two-column-image-grid />
    </app-component-card>
  </div>

  <div>
    <app-component-card title="Image in 3 Grid">
      <app-three-column-image-grid />
    </app-component-card>
  </div>
</div>